import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  purchaseData: {},
  isLoading: false,
  error: "",
  hasData: false,
  purchaseDataStatus: {
    status: false,
    message: ""
  }
};
const insurancePurchaseSlice = createSlice({
  name: "insurancePurchase",
  initialState,
  reducers: {
    insurancePurchaseRequest: state => {
      state.isLoading = true;
    },
    insurancePurchaseSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.purchaseData = action.payload;
      state.purchaseDataStatus.status = true;
    },
    insurancePurchaseFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = true;
      state.purchaseDataStatus.status = false;
    },
    resetPurchase: state => {
      state.purchaseDataStatus.status = false;
      state.isLoading = false;
      state.hasData = false;
      state.error = "";
      state.purchaseData = {};
    }
  }
});
export const {
  insurancePurchaseRequest,
  insurancePurchaseSuccess,
  insurancePurchaseFailure,
  resetPurchase
} = insurancePurchaseSlice.actions;
export default insurancePurchaseSlice.reducer;